/**
 * @fileoverview POST handler for the "/alloys/gemini/agentic/:app_group_id/oauth/connect" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysGeminiAgenticOauthConnectCacheKeys } from "./constants";
import type { PostAlloysGeminiAgenticOauthConnectProps, PostAlloysGeminiAgenticOauthConnectResult } from "./types";

export const postAlloysGeminiAgenticAppGroupIdOauthConnect = reactQueryMutationAdapter(
  postAlloysGeminiAgenticOauthConnectCacheKeys,
  (props: PostAlloysGeminiAgenticOauthConnectProps): Promise<PostAlloysGeminiAgenticOauthConnectResult> => {
    return fetch(`/alloys/gemini/agentic/${props.appGroupId}/oauth/connect`, "POST", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
